import { render, staticRenderFns } from "./ShopNow.vue?vue&type=template&id=e1bf968c&"
import script from "./ShopNow.vue?vue&type=script&lang=js&"
export * from "./ShopNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports